import { render, staticRenderFns } from "./ModuleImageForm.vue?vue&type=template&id=5d540b83&scoped=true"
import script from "./ModuleImageForm.vue?vue&type=script&lang=js"
export * from "./ModuleImageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d540b83",
  null
  
)

export default component.exports